<template>
  <header>
    <div class="header-content container flex">
      <div class="col-3 keep-col-size">
        <img :src="logoUrl" class="logo" />
      </div>
      <div class="col-9 keep-col-size">
        <button
          class="p-t-md p-b-md float-right burger-button"
          @click="toggleMenuClass"
        >
          <icon name="bars" scale="1.75" />
        </button>
        <ul :class="`main-menu float-right block z-index-2 opened-${menuOpened} bg-white`">
          <menu-item
            class="float-left p-l-md"
            v-for="menuItem in menuItems"
            :key="menuItem.ID"
            :item="menuItem"
          />
        </ul>
      </div>
    </div>
  </header>
</template>
<script>
import icon from 'vue-awesome/components/Icon';
import menuItem from '@/components/menuItem.vue';

export default {
	name: 'app-header',

	components: {
		menuItem,
		icon,
	},

	data() {
		return {
			menuOpened: false,
		};
	},

	props: {
		menuItems: {
			type: Array,
			default: () => [],
		},
		logoUrl: {
			type: String,
			default: '',
		},
	},

	methods: {
		toggleMenuClass() {
			this.menuOpened = !this.menuOpened;
		},
	},
};
</script>

<style lang="scss" scoped>

  $menu_breakpoint: 60rem;

  .header-content {
    max-height: 5.6rem;
    @media screen and (min-width: $menu_breakpoint) {
      overflow: visible;
    }
  }

  .logo{
    max-height: 5rem;
    @media screen and (min-width: $menu_breakpoint) {
      max-height: 10rem;
    }
  }

  .main-menu {
    display: none;

    @media screen and (min-width: $menu_breakpoint) {
      display: block;
    }

    &.opened-true {
      display: block;
      position: absolute;
      left: 0;
      top: 4.1rem;
      width: 100%;
    }
  }

  .burger-button {
    background: transparent;
    border: none;

    &:focus {
      outline: none;
    }

    @media screen and (min-width: $menu_breakpoint) {
      display: none;
    }
  }
</style>
